import React, { useState, useEffect } from 'react';
import { Button, Card, message, Upload, Input, Form, Modal, Select, Switch, Space, Divider } from 'antd';
import { DownloadOutlined, UploadOutlined, DatabaseOutlined, ClockCircleOutlined } from '@ant-design/icons';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { 
  collection, 
  getDocs, 
  initializeFirestore, 
  connectFirestoreEmulator,
  writeBatch,
  getFirestore,
  doc
} from 'firebase/firestore';
import { initializeApp, getApps } from 'firebase/app';
import { db } from '../firebase';
import type { UploadFile } from 'antd/es/upload/interface';
import Footer from '../components/Footer';
import '../styles/Database.css';
import { logUserAction } from '../utils/logUtils';
import { auth } from '../firebase';

const BACKUP_PROJECT_ID = 'normexport-secours';
const BACKUP_PROJECT_NUMBER = '648803697476';
const BACKUP_API_KEY = 'AIzaSyBo8WYJ4ofH8K02C-vz6NEGSkOQLWQf8hk';

// Configuration de la clé de service
const BACKUP_SERVICE_ACCOUNT = {
  type: "service_account",
  project_id: "normexport-secours",
  private_key_id: "a71a457cea527a91ae0e8beadecc87c538fe3c0a",
  private_key: "-----BEGIN PRIVATE KEY-----\nMIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQCyhy+NLjTRfJZV\neZfL5kOqKp+2/Mwy0rfTCusPA2YCNxkOcPaPB2l8CRYCKhXYJSuqyL2L5e8u6jUe\njeHHRPhZtzaC0GuCkFo1jsERXs4eA6o6+yRPE/8pOJtdrC4Zyd070x3/8INOBKCF\n+Gm21f8CpttuT9ORMgK74sc8rAzq2xVchwU8pzY+Bie30dNuvvpGXurF5tFQZ2hV\ngfh6Mt0Bgr1BdlliZeii/MFNXbVPGz0KUgC6/RZUDCoKhliYTW3aZjZJUyCqjZr7\ngUAg7ZbkyA6B6jPxg1KwPowXXCcDsE4kvBSBA9o8UdmihNj3m+VibEXF9oCy9ryK\nPijf8oqlAgMBAAECggEADH1b1LJwGbIajq8eRnKc9sAbItvjiZsHfGarObETl0w/\n/uw6ZO4QPDrNf51uoEu/bD1gJ16mIaqFyKtalDc4HFyuiK8olP6Lf8DgMxp7wd/1\n7kDo0iB0bYTrN6iGpCFkznKPYCW1JfA5w7hJ5bOUbtzPWqkP2dH9ciQO1hOKUXl1\nPzRr7JzNY4noW4swTI7BfJpdpSP2NNOqsafksL2ZcI64D8LYxrLtLRFZr9oBM0jo\nlSPn7cr7X0DuKVrCpC1fc/RAWnOWyHULCy8XN9kKi8egmyZhRGLwGeLmtjZ+M12f\nPVvwiEC9DU8wF4NgjDaFCMBp78ZrZlYu+WNljpL4sQKBgQD1G4xPMW9KqL/JPCYG\nDyMHMXvPy7YDdzA8T6k0Qp6ttZgcBxuIjdi01IVPqOCyWjsb43E/kiMDHNM5YbIA\n6GB+ddPIbCKnTP0+/nqvs0VSIWBcBh4vFMdapCIh0ClhsmugbDV9X+U3oN1eZ9h9\nsXL7ozUeLICWHiMIanFc98E/9QKBgQC6djMVY9Iso9rGknCjvTuHZH9xt48raYrz\nnHiv7p+KtD2RARds1zrKty+7idzh546v7eAc+8d30oVGuRKUmP/tAZoVrfS4z3RK\n8imvc/KSmSy0TlapngF/nHV+rMUT82CSXNH+HIV7DMmE8n+l0FIFnemhgVRGb0Xq\nd25rXDPh8QKBgQC/CtbEzwoojfjWF5ynclrh+26+WtAmSVr+VzTR9+8IBBdoGR4b\nxDuZTmAN49onCW8y4Ibffr7taSU1f3EnhffX+Wy1tZsY/UgSNnVXxwoL5tndQCN8\nnNx5SJ8V7dKjRFbg9haG/xyAzFBeieBSr+GoQuBfAV7EIv85SwXK6YzllQKBgEcN\nNWgIMpV6FqqmMK/kMuPjwsCFbtPfEujDjiWUK01CY1d28AM0fJ20ckbnQLkAcJnP\nbh/9PUQGf2y0p0TijFs2yg1KzT8DJlBMuN+3sg50udk3JMTbhbyn1QnhMfPpQLpl\nDkvjeGWsOLolYcjAehDT3KwDSSbRzfWLbxMP/mExAoGBALMgAOwUtfjPcLd/mPZb\nJdiiBqApE7YyoP1YvSvermc6jgnO7ijbyP9vx9bivJZk93GroWTzPq5wAmHOh18S\n0A/LmY3TzZg1sktct4iaSPUQCLsT08OJcH/yN1gubxy/iXsOj5oSgN7qW5QXDxGo\n4IL1b+LW4FV617rBC2T/BZ3x\n-----END PRIVATE KEY-----\n",
  client_email: "firebase-adminsdk-fbsvc@normexport-secours.iam.gserviceaccount.com",
  client_id: "103244994494386738944",
  auth_uri: "https://accounts.google.com/o/oauth2/auth",
  token_uri: "https://oauth2.googleapis.com/token",
  auth_provider_x509_cert_url: "https://www.googleapis.com/oauth2/v1/certs",
  client_x509_cert_url: "https://www.googleapis.com/robot/v1/metadata/x509/firebase-adminsdk-fbsvc%40normexport-secours.iam.gserviceaccount.com",
  universe_domain: "googleapis.com"
};

const Database: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [scheduledBackupEnabled, setScheduledBackupEnabled] = useState(false);
  const [backupFrequency, setBackupFrequency] = useState<'daily' | 'weekly' | 'monthly'>('weekly');
  const [lastBackupDate, setLastBackupDate] = useState<string | null>(null);
  const [nextBackupDate, setNextBackupDate] = useState<string | null>(null);

  // Initialiser le formulaire avec la clé API
  React.useEffect(() => {
    form.setFieldsValue({
      apiKey: BACKUP_API_KEY
    });
  }, [form]);

  // Charger les paramètres de sauvegarde programmée depuis localStorage
  useEffect(() => {
    const savedSettings = localStorage.getItem('backupSettings');
    if (savedSettings) {
      const settings = JSON.parse(savedSettings);
      setScheduledBackupEnabled(settings.enabled || false);
      setBackupFrequency(settings.frequency || 'weekly');
      setLastBackupDate(settings.lastBackupDate || null);
      setNextBackupDate(settings.nextBackupDate || null);
    }
  }, []);

  // Sauvegarder les paramètres dans localStorage
  const saveBackupSettings = (enabled: boolean, frequency: 'daily' | 'weekly' | 'monthly') => {
    const settings = {
      enabled,
      frequency,
      lastBackupDate,
      nextBackupDate
    };
    localStorage.setItem('backupSettings', JSON.stringify(settings));
  };

  // Calculer la prochaine date de sauvegarde
  const calculateNextBackupDate = (frequency: 'daily' | 'weekly' | 'monthly') => {
    const now = new Date();
    const nextDate = new Date(now);
    
    if (frequency === 'daily') {
      nextDate.setDate(now.getDate() + 1);
    } else if (frequency === 'weekly') {
      nextDate.setDate(now.getDate() + 7);
    } else {
      nextDate.setMonth(now.getMonth() + 1);
    }
    
    return nextDate.toISOString().split('T')[0];
  };

  // Vérifier si une sauvegarde programmée est due
  const checkScheduledBackup = () => {
    if (!scheduledBackupEnabled || !nextBackupDate) return false;
    
    const today = new Date().toISOString().split('T')[0];
    return today >= nextBackupDate;
  };

  // Exécuter une sauvegarde programmée
  const executeScheduledBackup = async () => {
    if (!checkScheduledBackup()) return;
    
    try {
      console.log('Exécution de la sauvegarde programmée...');
      await handleFirestoreBackup();
      
      // Mettre à jour les dates
      const now = new Date().toISOString().split('T')[0];
      const next = calculateNextBackupDate(backupFrequency);
      
      setLastBackupDate(now);
      setNextBackupDate(next);
      
      // Sauvegarder les nouvelles dates
      const settings = {
        enabled: scheduledBackupEnabled,
        frequency: backupFrequency,
        lastBackupDate: now,
        nextBackupDate: next
      };
      localStorage.setItem('backupSettings', JSON.stringify(settings));
      
      message.success('Sauvegarde programmée exécutée avec succès');
    } catch (error) {
      console.error('Erreur lors de la sauvegarde programmée:', error);
      message.error('Erreur lors de la sauvegarde programmée');
    }
  };

  // Vérifier les sauvegardes programmées au chargement de la page
  useEffect(() => {
    if (scheduledBackupEnabled) {
      executeScheduledBackup();
    }
  }, [scheduledBackupEnabled]);

  // Gérer l'activation/désactivation de la sauvegarde programmée
  const handleScheduledBackupToggle = (enabled: boolean) => {
    setScheduledBackupEnabled(enabled);
    
    if (enabled) {
      const nextDate = calculateNextBackupDate(backupFrequency);
      setNextBackupDate(nextDate);
      saveBackupSettings(enabled, backupFrequency);
      message.success(`Sauvegarde programmée activée (${backupFrequency === 'daily' ? 'quotidienne' : backupFrequency === 'weekly' ? 'hebdomadaire' : 'mensuelle'})`);
    } else {
      setNextBackupDate(null);
      saveBackupSettings(enabled, backupFrequency);
      message.info('Sauvegarde programmée désactivée');
    }
  };

  // Gérer le changement de fréquence
  const handleFrequencyChange = (frequency: 'daily' | 'weekly' | 'monthly') => {
    setBackupFrequency(frequency);
    
    if (scheduledBackupEnabled) {
      const nextDate = calculateNextBackupDate(frequency);
      setNextBackupDate(nextDate);
      saveBackupSettings(scheduledBackupEnabled, frequency);
      message.success(`Fréquence de sauvegarde changée (${frequency === 'daily' ? 'quotidienne' : frequency === 'weekly' ? 'hebdomadaire' : 'mensuelle'})`);
    }
  };

  // Exécuter une sauvegarde programmée manuellement
  const handleManualScheduledBackup = () => {
    Modal.confirm({
      title: 'Exécuter la sauvegarde programmée',
      content: 'Voulez-vous exécuter immédiatement la sauvegarde programmée vers la base de secours ?',
      okText: 'Oui, exécuter',
      cancelText: 'Annuler',
      onOk() {
        executeScheduledBackup();
      },
      onCancel() {
        message.info('Sauvegarde programmée annulée.');
      },
    });
  };

  const handleBackup = async () => {
    try {
      setLoading(true);
      const zip = new JSZip();
      
      // Récupérer toutes les collections
      const collections = ['users', 'products', 'orders']; // Ajoutez vos collections ici
      
      for (const collectionName of collections) {
        const querySnapshot = await getDocs(collection(db, collectionName));
        const data = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        // Ajouter les données au zip
        zip.file(`${collectionName}.json`, JSON.stringify(data, null, 2));
      }
      
      // Générer et télécharger le fichier zip
      const content = await zip.generateAsync({ type: 'blob' });
      saveAs(content, `backup-${new Date().toISOString().split('T')[0]}.zip`);
      
      // Log de la sauvegarde
      const currentUser = auth.currentUser;
      if (currentUser?.email) {
        await logUserAction(
          currentUser.email,
          "Sauvegarde base de données",
          "Sauvegarde de la base de données effectuée"
        );
      }
      
      message.success('Sauvegarde effectuée avec succès');
    } catch (error) {
      console.error('Erreur lors de la sauvegarde:', error);
      message.error('Erreur lors de la sauvegarde');
    } finally {
      setLoading(false);
    }
  };

  const handleRestore = async (file: File) => {
    try {
      setLoading(true);
      const zip = new JSZip();
      const zipContent = await zip.loadAsync(file);
      
      // Traiter chaque fichier JSON dans le zip
      for (const [filename, zipFile] of Object.entries(zipContent.files)) {
        if (filename.endsWith('.json')) {
          const content = await (zipFile as { async: (type: string) => Promise<string> }).async('string');
          const data = JSON.parse(content);
          const collectionName = filename.replace('.json', '');
          
          // Ici, vous devrez implémenter la logique pour restaurer les données
          // dans votre base de données Firebase
          console.log(`Restauration de ${collectionName}:`, data);
        }
      }
      
      // Log de la restauration
      const currentUser = auth.currentUser;
      if (currentUser?.email) {
        await logUserAction(
          currentUser.email,
          "Restauration base de données",
          "Restauration de la base de données effectuée"
        );
      }
      
      message.success('Restauration effectuée avec succès');
    } catch (error) {
      console.error('Erreur lors de la restauration:', error);
      message.error('Erreur lors de la restauration');
    } finally {
      setLoading(false);
    }
  };

  const handleFirestoreBackup = async () => {
    try {
      setLoading(true);
      
      // Vérifier que l'utilisateur est authentifié
      const currentUser = auth.currentUser;
      if (!currentUser) {
        message.error('Vous devez être connecté pour effectuer une sauvegarde');
        return;
      }

      console.log('Utilisateur authentifié:', currentUser.email);
      console.log('Début de la sauvegarde vers la base de secours...');
      
      // Collections à sauvegarder
      const collections = ['Users', 'prospects', 'UserLogs', 'Coordinates', 'MailTypes', 'Types'];
      const successfulBackups = [];
      const failedBackups = [];
      
      // Étape 1: Lire toutes les données depuis la base principale
      console.log('Étape 1: Lecture des données depuis la base principale...');
      const allData: any = {};
      
      for (const collectionName of collections) {
        try {
          console.log(`Lecture de la collection ${collectionName} depuis la base principale...`);
          const sourceSnapshot = await getDocs(collection(db, collectionName));
          console.log(`Nombre de documents trouvés dans ${collectionName}:`, sourceSnapshot.size);
          
          if (sourceSnapshot.empty) {
            console.log(`Collection ${collectionName} est vide`);
            allData[collectionName] = [];
            continue;
          }
          
          const data = sourceSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
          
          allData[collectionName] = data;
          console.log(`Données lues pour ${collectionName}:`, data.length, 'documents');
          
        } catch (readError: any) {
          console.error(`Erreur lors de la lecture de la collection ${collectionName}:`, readError);
          failedBackups.push(`${collectionName} (lecture): ${readError.message}`);
          allData[collectionName] = null; // Marquer comme échoué
        }
      }
      
      // Étape 2: Essayer d'écrire dans la base de secours avec les règles temporaires
      console.log('Étape 2: Tentative d\'écriture dans la base de secours...');
      let firestoreBackupSuccess = false;
      
      try {
        const backupApp = initializeApp({
          projectId: BACKUP_PROJECT_ID,
          apiKey: BACKUP_API_KEY,
          authDomain: `${BACKUP_PROJECT_ID}.firebaseapp.com`,
          storageBucket: `${BACKUP_PROJECT_ID}.appspot.com`
        }, 'backup-app');
        
        const secondaryDb = getFirestore(backupApp);
        
        for (const collectionName of collections) {
          if (allData[collectionName] === null || allData[collectionName].length === 0) {
            continue;
          }
          
          try {
            console.log(`Écriture de ${allData[collectionName].length} documents dans ${collectionName}...`);
            
            // Écrire par batch pour éviter les limites de taille
            const batchSize = 500;
            const data = allData[collectionName];
            
            for (let i = 0; i < data.length; i += batchSize) {
              const batch = writeBatch(secondaryDb);
              const batchData = data.slice(i, i + batchSize);
              
              batchData.forEach((docData: any) => {
                const docRef = doc(collection(secondaryDb, collectionName), docData.id);
                batch.set(docRef, docData);
              });
              
              await batch.commit();
              console.log(`Batch ${Math.floor(i/batchSize) + 1} écrit avec succès pour ${collectionName}`);
            }
            
            console.log(`Collection ${collectionName} sauvegardée avec succès`);
            successfulBackups.push(collectionName);
            firestoreBackupSuccess = true;
            
          } catch (writeError: any) {
            console.error(`Erreur lors de l'écriture de la collection ${collectionName}:`, writeError);
            failedBackups.push(`${collectionName} (écriture): ${writeError.message}`);
          }
        }
      } catch (firestoreError: any) {
        console.error('Erreur lors de l\'initialisation de la base de secours:', firestoreError);
        failedBackups.push(`Base de secours: ${firestoreError.message}`);
      }
      
      // Étape 3: Si la sauvegarde Firestore échoue, sauvegarder dans un fichier JSON
      if (!firestoreBackupSuccess) {
        console.log('Étape 3: Sauvegarde de secours dans un fichier JSON...');
        try {
          const backupData = {
            timestamp: new Date().toISOString(),
            user: currentUser.email,
            collections: allData
          };
          
          const zip = new JSZip();
          
          // Ajouter chaque collection comme fichier JSON séparé
          for (const collectionName of collections) {
            if (allData[collectionName] !== null) {
              zip.file(`${collectionName}.json`, JSON.stringify(allData[collectionName], null, 2));
            }
          }
          
          // Ajouter un fichier de métadonnées
          zip.file('backup-metadata.json', JSON.stringify({
            timestamp: backupData.timestamp,
            user: backupData.user,
            collections: collections.map(name => ({
              name,
              count: allData[name]?.length || 0,
              status: allData[name] === null ? 'failed' : 'success'
            }))
          }, null, 2));
          
          // Générer et télécharger le fichier zip
          const content = await zip.generateAsync({ type: 'blob' });
          saveAs(content, `firestore-backup-${new Date().toISOString().split('T')[0]}.zip`);
          
          successfulBackups.push('Fichier JSON de secours');
          message.success('Sauvegarde de secours créée en fichier JSON (téléchargement automatique)');
          
        } catch (fileError: any) {
          console.error('Erreur lors de la création du fichier de sauvegarde:', fileError);
          failedBackups.push(`Fichier de secours: ${fileError.message}`);
        }
      }
      
      // Afficher les résultats
      if (successfulBackups.length > 0) {
        message.success(`Collections sauvegardées avec succès: ${successfulBackups.join(', ')}`);
      }
      
      if (failedBackups.length > 0) {
        message.warning(`Collections non sauvegardées: ${failedBackups.join(', ')}`);
      }
      
      if (successfulBackups.length > 0) {
        message.success('Sauvegarde effectuée avec succès');
      } else {
        message.error('Aucune collection n\'a pu être sauvegardée');
      }
      
    } catch (error: any) {
      console.error('Erreur détaillée lors de la sauvegarde Firestore:', error);
      message.error(`Erreur lors de la sauvegarde: ${error.message || 'Erreur inconnue'}`);
    } finally {
      setLoading(false);
    }
  };

  const handleFirestoreRestore = async () => {
    try {
      setLoading(true);

      // Vérifier que l'utilisateur est authentifié
      const currentUser = auth.currentUser;
      if (!currentUser) {
        message.error('Vous devez être connecté pour effectuer une restauration');
        return;
      }

      console.log('Utilisateur authentifié pour restauration:', currentUser.email);

      const backupApp = initializeApp({
        projectId: BACKUP_PROJECT_ID,
        apiKey: BACKUP_API_KEY,
        authDomain: `${BACKUP_PROJECT_ID}.firebaseapp.com`,
        storageBucket: `${BACKUP_PROJECT_ID}.appspot.com`
      }, 'backup-app-restore'); // Nom unique pour l'application de restauration
      
      const secondaryDb = getFirestore(backupApp);

      // Collections avec leurs permissions spécifiques
      const collections = [
        { name: 'Users', requiresAuth: true },
        { name: 'prospects', requiresAuth: true },
        { name: 'UserLogs', requiresAuth: true },
        { name: 'Coordinates', requiresAuth: true },
        { name: 'MailTypes', requiresAuth: true },
        { name: 'Types', requiresAuth: true }
      ];

      const successfulRestores = [];
      const failedRestores = [];

      for (const collectionInfo of collections) {
        try {
          console.log(`Tentative de restauration de la collection ${collectionInfo.name}...`);
          const sourceSnapshot = await getDocs(collection(secondaryDb, collectionInfo.name));
          console.log(`Nombre de documents trouvés dans ${collectionInfo.name} pour la restauration:`, sourceSnapshot.size);

          if (sourceSnapshot.empty) {
            console.log(`Aucune donnée trouvée dans la collection ${collectionInfo.name} pour la restauration.`);
            successfulRestores.push(`${collectionInfo.name} (vide)`);
            continue;
          }

          const batch = writeBatch(db); // Utiliser la base de données principale pour la restauration
          sourceSnapshot.docs.forEach(docSnap => {
            const docRef = doc(collection(db, collectionInfo.name), docSnap.id);
            batch.set(docRef, docSnap.data(), { merge: true }); // Utiliser merge pour éviter d'écraser les documents existants si non voulu
          });
          await batch.commit();
          console.log(`Collection ${collectionInfo.name} restaurée avec succès.`);
          successfulRestores.push(collectionInfo.name);

        } catch (collectionError: any) {
          console.error(`Erreur lors de la restauration de la collection ${collectionInfo.name}:`, collectionError);
          failedRestores.push(`${collectionInfo.name}: ${collectionError.message || 'Erreur inconnue'}`);
          
          // Continuer avec les autres collections même si une échoue
          continue;
        }
      }

      // Afficher les résultats
      if (successfulRestores.length > 0) {
        message.success(`Collections restaurées avec succès: ${successfulRestores.join(', ')}`);
      }
      
      if (failedRestores.length > 0) {
        message.warning(`Collections non restaurées: ${failedRestores.join(', ')}`);
      }

      if (successfulRestores.length > 0) {
        message.success('Restauration de la base Firestore secondaire effectuée avec succès !');
      } else {
        message.error('Aucune collection n\'a pu être restaurée');
      }
      
    } catch (error: any) {
      console.error('Erreur détaillée lors de la restauration Firestore:', error);
      message.error(`Erreur lors de la restauration depuis la base secondaire: ${error.message || 'Erreur inconnue'}`);
    } finally {
      setLoading(false);
    }
  };

  // Fonction pour tester les permissions d'accès aux collections
  const testCollectionPermissions = async () => {
    try {
      const currentUser = auth.currentUser;
      if (!currentUser) {
        message.error('Vous devez être connecté pour tester les permissions');
        return;
      }

      const collections = ['Users', 'prospects', 'UserLogs', 'Coordinates', 'MailTypes', 'Types'];
      const results = [];

      for (const collectionName of collections) {
        try {
          const testSnapshot = await getDocs(collection(db, collectionName));
          results.push(`✅ ${collectionName}: ${testSnapshot.size} documents accessibles`);
        } catch (error: any) {
          results.push(`❌ ${collectionName}: ${error.message}`);
        }
      }

      Modal.info({
        title: 'Test des permissions d\'accès aux collections',
        content: (
          <div>
            <p><strong>Utilisateur connecté :</strong> {currentUser.email}</p>
            <div style={{ marginTop: '16px' }}>
              {results.map((result, index) => (
                <div key={index} style={{ marginBottom: '8px', fontFamily: 'monospace' }}>
                  {result}
                </div>
              ))}
            </div>
          </div>
        ),
        width: 600,
      });
    } catch (error: any) {
      message.error(`Erreur lors du test des permissions: ${error.message}`);
    }
  };

  const handleConfirmBackup = () => {
    Modal.confirm({
      title: 'Confirmer la sauvegarde',
      content: 'Êtes-vous sûr de vouloir sauvegarder les collections vers la base de secours ? Les données existantes sur la base de secours seront mises à jour.',
      okText: 'Oui, sauvegarder',
      cancelText: 'Annuler',
      onOk() {
        handleFirestoreBackup();
      },
      onCancel() {
        message.info('Sauvegarde annulée.');
      },
    });
  };

  const handleConfirmRestore = () => {
    Modal.confirm({
      title: 'Confirmer la restauration',
      content: 'Êtes-vous sûr de vouloir restaurer les collections depuis la base de secours ? Cela pourrait modifier ou écraser les données existantes dans votre base de données principale.',
      okText: 'Oui, restaurer',
      cancelText: 'Annuler',
      onOk() {
        handleFirestoreRestore();
      },
      onCancel() {
        message.info('Restauration annulée.');
      },
    });
  };

  return (
    <>
      <div className="database-page" style={{ padding: '24px', marginTop: '80px', minHeight: 'calc(100vh - 160px)' }}>
        <Card title="Sauvegarde et Restauration de la Base de Données" style={{ marginBottom: '24px' }}>
          <div style={{ display: 'flex', gap: '16px' }}>
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              onClick={handleBackup}
              loading={loading}
            >
              Sauvegarder la base de données
            </Button>
            
            <Upload
              accept=".zip"
              showUploadList={false}
              beforeUpload={(file: UploadFile) => {
                if (file instanceof File) {
                  handleRestore(file);
                }
                return false;
              }}
            >
              <Button
                icon={<UploadOutlined />}
                loading={loading}
              >
                Restaurer depuis un fichier
              </Button>
            </Upload>
          </div>
        </Card>

        <Card title="Sauvegarde et Restauration de la base de secours Firestore">
          <div style={{ marginBottom: '16px', textAlign: 'left' }}>
            <p style={{ margin: '0', width: '100%', textAlign: 'left' }}><strong>Projet de secours :</strong> {BACKUP_PROJECT_ID}</p>
            <p style={{ margin: '0', width: '100%', textAlign: 'left' }}><strong>Numéro du projet :</strong> {BACKUP_PROJECT_NUMBER}</p>
            <p style={{ margin: '0', width: '100%', textAlign: 'left' }}><strong>Clé API :</strong> {BACKUP_API_KEY}</p>
          </div>
          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
            <Button
              type="primary"
              icon={<DatabaseOutlined />}
              onClick={handleConfirmBackup}
              loading={loading}
            >
              Sauvegarder vers la base de secours
            </Button>
            <Button
              type="default"
              icon={<DatabaseOutlined />}
              onClick={handleConfirmRestore}
              loading={loading}
            >
              Restaurer depuis la base de secours
            </Button>
            <Button
              type="default"
              icon={<ClockCircleOutlined />}
              onClick={testCollectionPermissions}
              style={{ backgroundColor: '#52c41a', borderColor: '#52c41a', color: 'white' }}
            >
              Tester les permissions
            </Button>
          </div>
          <div style={{ 
            marginTop: '16px', 
            padding: '12px', 
            backgroundColor: '#fff7e6', 
            borderRadius: '6px',
            border: '1px solid #ffd591'
          }}>
            <p style={{ margin: '0', fontSize: '14px', color: '#d46b08' }}>
              💡 <strong>Conseil :</strong> Utilisez le bouton "Tester les permissions" pour vérifier quelles collections sont accessibles avec votre compte actuel avant de faire une sauvegarde.
            </p>
          </div>
        </Card>

        <Card title="Sauvegarde Programmée" style={{ marginTop: '24px' }}>
          <div style={{ marginBottom: '16px' }}>
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <Switch
                  checked={scheduledBackupEnabled}
                  onChange={handleScheduledBackupToggle}
                  size="default"
                />
                <span style={{ fontSize: '16px', fontWeight: 500 }}>
                  Activer la sauvegarde automatique
                </span>
              </div>

              {scheduledBackupEnabled && (
                <>
                  <Divider style={{ margin: '8px 0' }} />
                  
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <span style={{ minWidth: '120px' }}>Fréquence :</span>
                    <Select
                      value={backupFrequency}
                      onChange={handleFrequencyChange}
                      style={{ width: 150 }}
                      options={[
                        { value: 'daily', label: 'Quotidienne' },
                        { value: 'weekly', label: 'Hebdomadaire' },
                        { value: 'monthly', label: 'Mensuelle' }
                      ]}
                    />
                  </div>

                  <div style={{ 
                    padding: '12px', 
                    backgroundColor: '#f6f8fa', 
                    borderRadius: '6px',
                    border: '1px solid #d1d9e0'
                  }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      <div>
                        <strong>Dernière sauvegarde :</strong>{' '}
                        {lastBackupDate ? (
                          <span style={{ color: '#28a745' }}>
                            {new Date(lastBackupDate).toLocaleDateString('fr-FR')}
                          </span>
                        ) : (
                          <span style={{ color: '#6c757d' }}>Aucune sauvegarde programmée effectuée</span>
                        )}
                      </div>
                      <div>
                        <strong>Prochaine sauvegarde :</strong>{' '}
                        {nextBackupDate ? (
                          <span style={{ color: '#007bff' }}>
                            {new Date(nextBackupDate).toLocaleDateString('fr-FR')}
                          </span>
                        ) : (
                          <span style={{ color: '#6c757d' }}>Non programmée</span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div style={{ 
                    padding: '8px 12px', 
                    backgroundColor: '#e3f2fd', 
                    borderRadius: '4px',
                    border: '1px solid #bbdefb'
                  }}>
                    <span style={{ fontSize: '14px', color: '#1976d2' }}>
                      💡 Les sauvegardes programmées s'exécutent automatiquement lorsque vous ouvrez cette page.
                      Assurez-vous de visiter régulièrement cette section pour déclencher les sauvegardes.
                    </span>
                  </div>

                  <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
                    <Button
                      type="primary"
                      icon={<ClockCircleOutlined />}
                      onClick={handleManualScheduledBackup}
                      loading={loading}
                      size="small"
                    >
                      Exécuter maintenant
                    </Button>
                  </div>
                </>
              )}
            </Space>
          </div>
        </Card>
      </div>
      <Footer />
    </>
  );
};

export default Database; 